export default __webpack_public_path__ + "static/og-img-logo-ganztags-167fac5f46d05273561dec97503e9c9f.png";